module.exports = __webpack_public_path__ + "static/media/Agri.2d359588.png";